module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAUZJREFUaAXtWcFtAjEQHCP+UAIdQH6IT2qhg6QS6IAa6IBXlB+UkHSQNIAzBk4CyXufiXyJNP74tPbszs7cffYALytgBazAkAqkvuLLHWa8sOGdBfdZ393fPsvAB3OeuL++ry/P1RJhA4X8CDgSNa0i2wW/zsBT1AQ51tcoY8uTockXctMblyrRsAEkPFcRAwRzwjwqO44OGH9Q/23Nlhqu1Q58/a+r7/uLHejQf3x3A0MbZAfsgKiAXyFRQBluB2QJxQR2QBRQhtsBWUIxgR0QBZThdkCWUExgB0QBZbgdkCUUE9gBUUAZbgdkCcUE/96BcDaaM75TwqQT6H5W2cVa7eTyGdUKHeBA9RCBWsfJ5RTVDBs4J7wUFyJgq3jhULhE9cIGyh8RzuUXHHLv+yyMEqvxS81SmxyivzNqDeOtgBWwAroCPxf+N8JsYa4EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/ic_check_box_OFF@2x.png
// module id = 1238
// module chunks = 0